import * as React from "react"
import { colors } from "../../styles"
import { defaultColor, IconPathProps } from "./IconMap"

// Note for adding new icons: export in a 24px viewBox and 16px wide icon
export const plus: React.FC<IconPathProps> = ({ color = defaultColor }) => (
	<>
		<rect x="11.1" y="4" width="1.7" height="16" fill={colors[color]} />
		<rect x="4" y="11.1" width="16" height="1.7" fill={colors[color]} />
	</>
)
export const minus: React.FC<IconPathProps> = ({ color = defaultColor }) => (
	<>
		<rect
			x="19.0016"
			y="12.75"
			width="14"
			height="1.5"
			transform="rotate(-180 19.0016 12.75)"
			fill={colors[color]}
		/>
	</>
)

export const heartFilled: React.FC<IconPathProps> = ({
	color = defaultColor,
}) => (
	<>
		<path
			d="M12 19.1195C11.8647 19.1195 11.7327 19.0636 11.6394 18.9656L5.24943 12.301C3.94918 11.0021 3.62794 9.01673 4.45502 7.36525C5.18479 5.90638 6.65432 5 8.28981 5C8.95693 5 9.59873 5.15195 10.1979 5.45119C10.6104 5.65713 10.9843 5.92704 11.3102 6.25294L12.0006 6.94272L12.6911 6.25294C13.4982 5.44586 14.5732 5.00133 15.7181 5.00133C16.8631 5.00133 17.9374 5.44586 18.7452 6.25294C19.0711 6.57884 19.341 6.95272 19.5469 7.36459C20.372 9.01473 20.0501 11.0008 18.7452 12.3057L12.3619 18.9649C12.2672 19.0636 12.1353 19.1195 12 19.1195ZM8.28648 5.99769C7.93459 5.99769 7.5847 6.055 7.24614 6.16763C6.4144 6.44488 5.74061 7.02869 5.34873 7.81245C4.71493 9.07805 4.96219 10.6009 5.96321 11.6013L12 17.8973L18.0294 11.6072C19.0351 10.6009 19.2837 9.07738 18.6512 7.81311C18.4933 7.49721 18.2867 7.21064 18.0367 6.96072C17.4183 6.34224 16.5939 6.00168 15.7168 6.00168C14.8397 6.00168 14.0153 6.34224 13.3969 6.96072L12.3532 8.00372C12.2586 8.09769 12.1333 8.14967 12 8.14967C11.8667 8.14967 11.7414 8.09769 11.6467 8.00372L10.6031 6.96005C10.3532 6.71079 10.0666 6.50419 9.75068 6.34624C9.28816 6.11498 8.79565 5.99769 8.28648 5.99769Z"
			fill={colors[color]}
		/>
		<path
			d="M7.0874 5.6956L7.08768 5.69551C7.47621 5.56626 7.87935 5.5 8.28586 5.5C8.87395 5.5 9.44289 5.63595 9.97367 5.90134C10.3377 6.08334 10.6679 6.32147 10.9555 6.60834L10.956 6.60881L11.9984 7.65123C11.9985 7.6513 11.9986 7.65137 11.9986 7.65143C11.9989 7.65166 11.9991 7.65184 11.9992 7.65199C11.9993 7.65199 11.9993 7.65199 11.9994 7.65199C11.9994 7.65199 11.9994 7.65199 11.9995 7.65199C11.9996 7.65184 11.9998 7.65165 12.0001 7.65141C12.0001 7.65136 12.0002 7.6513 12.0003 7.65123L13.0427 6.60948C13.7553 5.89684 14.7071 5.504 15.7162 5.504C16.7253 5.504 17.677 5.89684 18.3897 6.60948L18.0475 6.95162L18.3897 6.60948C18.6775 6.89736 18.9158 7.2278 19.0978 7.59182C19.8263 9.04812 19.5399 10.8016 18.3863 11.9592L12.3603 18.2456L11.9994 18.6221L11.6384 18.2456L5.60525 11.9533C4.45527 10.8008 4.17162 9.04772 4.9009 7.59115L7.0874 5.6956ZM7.0874 5.6956C6.13017 6.01468 5.35234 6.68846 4.90104 7.59087L7.0874 5.6956Z"
			fill={colors[color]}
			stroke={colors[color]}
		/>
	</>
)

export const heart: React.FC<IconPathProps> = ({ color = defaultColor }) => (
	<>
		<path
			d="M12 19.1195C11.8647 19.1195 11.7327 19.0636 11.6394 18.9656L5.24943 12.301C3.94918 11.0021 3.62794 9.01673 4.45502 7.36525C5.18479 5.90638 6.65432 5 8.28981 5C8.95693 5 9.59873 5.15195 10.1979 5.45119C10.6104 5.65713 10.9843 5.92704 11.3102 6.25294L12.0006 6.94272L12.6911 6.25294C13.4982 5.44586 14.5732 5.00133 15.7181 5.00133C16.8631 5.00133 17.9374 5.44586 18.7452 6.25294C19.0711 6.57884 19.341 6.95272 19.5469 7.36459C20.372 9.01473 20.0501 11.0008 18.7452 12.3057L12.3619 18.9649C12.2672 19.0636 12.1353 19.1195 12 19.1195ZM8.28648 5.99769C7.93459 5.99769 7.5847 6.055 7.24614 6.16763C6.4144 6.44488 5.74061 7.02869 5.34873 7.81245C4.71493 9.07805 4.96219 10.6009 5.96321 11.6013L12 17.8973L18.0294 11.6072C19.0351 10.6009 19.2837 9.07738 18.6512 7.81311C18.4933 7.49721 18.2867 7.21064 18.0367 6.96072C17.4183 6.34224 16.5939 6.00168 15.7168 6.00168C14.8397 6.00168 14.0153 6.34224 13.3969 6.96072L12.3532 8.00372C12.2586 8.09769 12.1333 8.14967 12 8.14967C11.8667 8.14967 11.7414 8.09769 11.6467 8.00372L10.6031 6.96005C10.3532 6.71079 10.0666 6.50419 9.75068 6.34624C9.28816 6.11498 8.79565 5.99769 8.28648 5.99769Z"
			fill={colors[color]}
		/>
	</>
)

export const user: React.FC<IconPathProps> = ({ color = defaultColor }) => (
	<>
		<path
			d="M12 12C9.79467 12 8 10.2053 8 8C8 5.79467 9.79467 4 12 4C14.2053 4 16 5.79467 16 8C16 10.2053 14.2053 12 12 12ZM12 5C10.346 5 9 6.346 9 8C9 9.654 10.346 11 12 11C13.654 11 15 9.654 15 8C15 6.346 13.654 5 12 5Z"
			fill={colors[color]}
		/>
		<path
			d="M18.5 20C18.224 20 18 19.776 18 19.5C18 16.1913 15.3087 13.5 12 13.5C8.69133 13.5 6 16.1913 6 19.5C6 19.776 5.776 20 5.5 20C5.224 20 5 19.776 5 19.5C5 15.64 8.14 12.5 12 12.5C15.86 12.5 19 15.64 19 19.5C19 19.776 18.776 20 18.5 20Z"
			fill={colors[color]}
		/>
	</>
)

export const arrowLeft: React.FC<IconPathProps> = ({
	color = defaultColor,
}) => (
	<path
		d="M6.9,11.3H20v1.5H6.9l4.4,4.4l-1.1,1.1L4,12l6.2-6.2l1.1,1.1L6.9,11.3z"
		fill={colors[color]}
	/>
)

export const arrowRight: React.FC<IconPathProps> = ({
	color = defaultColor,
}) => (
	<path
		d="M17.1,12.7H4v-1.5h13.1l-4.4-4.4l1.1-1.1L20,12l-6.2,6.2l-1.1-1.1L17.1,12.7z"
		fill={colors[color]}
	/>
)

export const arrowUp: React.FC<IconPathProps> = ({ color = defaultColor }) => (
	<path
		d="M11.3,8.9l-4.4,4.4l-1.1-1.1L12,6l6.2,6.2l-1.1,1.1l-4.4-4.4v9.7h-1.5V8.9z"
		fill={colors[color]}
	/>
)
export const arrowDown: React.FC<IconPathProps> = ({
	color = defaultColor,
}) => (
	<path
		d="M12.7516 15.6599L17.1279 11.2836L18.1886 12.3443L12.0014 18.5314L5.8142 12.3443L6.87486 11.2836L11.2516 15.6603L11.2516 6L12.7516 6L12.7516 15.6599Z"
		fill={colors[color]}
	/>
)
export const arrowUpRight: React.FC<IconPathProps> = ({
	color = defaultColor,
}) => (
	<path
		d="M16.4624 8.64179L7.17669 17.9275L6.11603 16.8668L15.4015 7.58138L9.21239 7.58138L9.21239 6.08138L17.9624 6.08138L17.9624 14.8314H16.4624V8.64179Z"
		fillRule="evenodd"
		clipRule="evenodd"
		fill={colors[color]}
	/>
)

export const close: React.FC<IconPathProps> = ({ color = defaultColor }) => (
	<path
		d="M13.1,12L20,5.1L18.9,4L12,10.9L5.1,4L4,5.1l6.9,6.9L4,18.9L5.1,20l6.9-6.9l6.9,6.9l1.1-1.1L13.1,12z"
		fill={colors[color]}
	/>
)

export const chevronDown: React.FC<IconPathProps> = ({
	color = defaultColor,
}) => (
	<path
		d="M19.7,7.4c0.3,0.3,0.4,0.7,0.2,1.1l-0.1,0.1L13,16.4c-0.2,0.3-0.6,0.4-1,0.4c-0.3,0-0.6-0.1-0.9-0.3L11,16.4
	L4.2,8.6C3.9,8.2,3.9,7.7,4.3,7.4c0.3-0.3,0.8-0.3,1.1,0l0.1,0.1L12,15l6.6-7.5C18.8,7.2,19.3,7.1,19.7,7.4L19.7,7.4z"
		fill={colors[color]}
	/>
)
export const chevronUp: React.FC<IconPathProps> = ({
	color = defaultColor,
}) => (
	<path
		d="M12.0015 9.18646L5.18788 15.9999L4.12722 14.9392L12.0015 7.06514L19.8757 14.9393L18.8151 16L12.0015 9.18646Z"
		fill={colors[color]}
	/>
)
export const chevronLeft: React.FC<IconPathProps> = ({
	color = defaultColor,
}) => (
	<path
		d="M9.18646 11.9985L15.9999 18.8121L14.9392 19.8728L7.06514 11.9985L14.9393 4.12427L16 5.18493L9.18646 11.9985Z"
		fill={colors[color]}
	/>
)
export const chevronRight: React.FC<IconPathProps> = ({
	color = defaultColor,
}) => (
	<path
		d="M14.8135 12.0015L8.00012 5.18788L9.06078 4.12722L16.9349 12.0015L9.06066 19.8757L8 18.8151L14.8135 12.0015Z"
		fill={colors[color]}
	/>
)

export const menu: React.FC<IconPathProps> = ({ color = defaultColor }) => (
	<>
		<path fill={colors[color]} d="M20,12.4H4v-0.9h16V12.4z" />
		<path fill={colors[color]} d="M20,6H4V5.1h16V6z" />
		<path fill={colors[color]} d="M20,18.9H4V18h16V18.9z" />
	</>
)

export const chevronMenuDown: React.FC<IconPathProps> = ({
	color = defaultColor,
}) => (
	<path
		d="M12,13.4l6.3-6.3L20,8.9l-8,8l-8-8l1.7-1.7L12,13.4z"
		fill={colors[color]}
	/>
)

export const warningTriangle: React.FC<IconPathProps> = ({
	color = defaultColor,
}) => (
	<>
		<path
			d="M5.5,19.5c-0.3,0-0.5-0.1-0.7-0.2c-0.7-0.4-1-1.3-0.6-2l6.5-12C10.8,5,11,4.8,11.3,4.7c0.2-0.1,0.5-0.2,0.7-0.2
	c0.1,0,0.3,0,0.4,0.1c0.4,0.1,0.7,0.4,0.9,0.7l6.5,12c0.1,0.2,0.2,0.5,0.2,0.7c0,0.8-0.7,1.5-1.5,1.5H5.5z M12,5.5
	c-0.1,0-0.2,0-0.2,0.1c-0.1,0-0.2,0.1-0.2,0.2l-6.5,12C5,17.9,5,18,5,18.1c0,0.1,0.1,0.2,0.2,0.3c0.1,0,0.2,0.1,0.2,0.1h13
	c0.3,0,0.5-0.2,0.5-0.5c0-0.1,0-0.2-0.1-0.2l-6.5-12c-0.1-0.1-0.2-0.2-0.3-0.2C12.1,5.5,12,5.5,12,5.5z"
			fill={colors[color]}
		/>
		<path
			d="M12,17C12,17,11.9,17,12,17c-0.4,0-0.7-0.3-0.7-0.7c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1c0-0.3,0.3-0.6,0.7-0.7c0,0,0.1,0,0.1,0
	c0,0,0.1,0,0.1,0c0.3,0,0.6,0.3,0.7,0.7c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1C12.7,16.7,12.4,17,12,17C12.1,17,12,17,12,17z"
			fill={colors[color]}
		/>
		<path
			d="M12,14.5c-0.3,0-0.5-0.2-0.5-0.5V9.5C11.5,9.2,11.7,9,12,9c0.3,0,0.5,0.2,0.5,0.5V14C12.5,14.3,12.3,14.5,12,14.5z"
			fill={colors[color]}
		/>
	</>
)

export const infoCircle: React.FC<IconPathProps> = ({
	color = defaultColor,
}) => (
	<>
		<path
			d="M13,15.5c-0.8,0-1.5-0.7-1.5-1.5v-2.5H11c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h0.5c0.6,0,1,0.4,1,1V14
	c0,0.3,0.2,0.5,0.5,0.5h0.5c0.3,0,0.5,0.2,0.5,0.5s-0.2,0.5-0.5,0.5H13z"
			fill={colors[color]}
		/>
		<circle cx="11.8" cy="8.8" r="0.8" fill={colors[color]} />
		<path
			d="M4,12c0,4.4,3.6,8,8,8s8-3.6,8-8s-3.6-8-8-8S4,7.6,4,12z M5,12c0-3.9,3.1-7,7-7s7,3.1,7,7s-3.1,7-7,7
	S5,15.9,5,12z"
			fill={colors[color]}
		/>
	</>
)

export const check: React.FC<IconPathProps> = ({ color = defaultColor }) => (
	<path
		d="M11.27,16.91c-0.37,0-0.71-0.15-0.97-0.42l-4.08-4.32c-0.3-0.32-0.29-0.83,0.03-1.13
	c0.32-0.3,0.83-0.29,1.13,0.03l3.85,4.08l5.31-7.72c0.25-0.36,0.75-0.46,1.11-0.21c0.36,0.25,0.46,0.75,0.21,1.11l-5.49,7.99
	c-0.23,0.33-0.59,0.54-1,0.57C11.34,16.91,11.3,16.91,11.27,16.91z"
		fill={colors[color]}
	/>
)

export const checkSolid: React.FC<IconPathProps> = ({ color = defaultColor }) => (
	<>
		<rect width="24" height="24" rx="12" fill="#407EC9" />
		<path d="M9.6222 17C9.51819 17 9.41329 16.9899 9.30928 16.9704C8.88969 16.891 8.52787 16.6621 8.29052 16.3251L6.12142 13.4006C5.90984 13.1151 5.98185 12.7189 6.28232 12.5178C6.39522 12.4418 6.52768 12.4021 6.66636 12.4021C6.88327 12.4021 7.08685 12.5026 7.21219 12.6707L9.39018 15.6079C9.43818 15.6763 9.49686 15.7143 9.56886 15.7278C9.58664 15.7312 9.60442 15.7329 9.6222 15.7329C9.67376 15.7329 9.72443 15.7177 9.76799 15.6898C9.79288 15.6738 9.81422 15.6543 9.832 15.6324L16.8122 7.23991C16.9385 7.08785 17.1287 7 17.3341 7C17.4834 7 17.6301 7.04815 17.7465 7.136C17.8861 7.24075 17.975 7.39111 17.9955 7.55922C18.0159 7.72732 17.967 7.89289 17.8568 8.02551L10.8845 16.4078C10.7841 16.5337 10.6561 16.6477 10.5085 16.7424C10.2445 16.9113 9.93779 17 9.6222 17Z" fill='#F0F4FA' />
	</>
)

export const filter: React.FC<IconPathProps> = ({ color = defaultColor }) => (
	<>
		<path
			d="M13.7,13c-1.5,0-2.8,1.1-3.2,2.5H4V17h6.6c0.3,1.4,1.6,2.5,3.1,2.5s2.8-1.1,3.2-2.5H20v-1.5h-3.1C16.6,14.1,15.3,13,13.7,13
	z M13.7,18c-1,0-1.8-0.8-1.8-1.8s0.8-1.8,1.8-1.8s1.8,0.8,1.8,1.8S14.7,18,13.7,18z"
			fill={colors[color]}
		/>
		<path
			d="M13.4,7c-0.3-1.4-1.6-2.5-3.1-2.5S7.4,5.6,7.1,7H4v1.5h3.1C7.4,9.9,8.7,11,10.3,11s2.8-1.1,3.1-2.5H20V7H13.4z M10.3,9.5
		c-1,0-1.8-0.8-1.8-1.8s0.8-1.8,1.8-1.8S12,6.8,12,7.7C12,8.7,11.2,9.5,10.3,9.5z"
			fill={colors[color]}
		/>
	</>
)

export const playCircle: React.FC<IconPathProps> = ({
	color = defaultColor,
}) => (
	<>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M12 5.14289C8.2129 5.14289 5.14286 8.21293 5.14286 12C5.14286 15.7871 8.2129 18.8572 12 18.8572C15.7871 18.8572 18.8571 15.7871 18.8571 12C18.8571 8.21293 15.7871 5.14289 12 5.14289ZM4 12C4 7.58175 7.58172 4.00003 12 4.00003C16.4183 4.00003 20 7.58175 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12Z"
			fill={colors[color]}
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M10.0087 8.64311C10.1903 8.5424 10.4124 8.54823 10.5885 8.65833L15.1599 11.5155C15.327 11.6199 15.4285 11.803 15.4285 12C15.4285 12.1971 15.327 12.3802 15.1599 12.4846L10.5885 15.3418C10.4124 15.4519 10.1903 15.4577 10.0087 15.357C9.82696 15.2563 9.71423 15.0649 9.71423 14.8572V9.1429C9.71423 8.93517 9.82696 8.74381 10.0087 8.64311ZM10.8571 10.1739V13.8262L13.7789 12L10.8571 10.1739Z"
			fill={colors[color]}
		/>
	</>
)

export const moreVertical: React.FC<IconPathProps> = ({
	color = defaultColor,
}) => (
	<>
		<path
			d="M12,7.2c-0.9,0-1.6-0.7-1.6-1.6S11.1,4,12,4s1.6,0.7,1.6,1.6S12.9,7.2,12,7.2z M12,5.6L12,5.6L12,5.6z"
			fill={colors[color]}
		/>
		<path
			d="M12,13.6c-0.9,0-1.6-0.7-1.6-1.6s0.7-1.6,1.6-1.6s1.6,0.7,1.6,1.6S12.9,13.6,12,13.6z M12,12L12,12L12,12z"
			fill={colors[color]}
		/>
		<path
			d="M12,20c-0.9,0-1.6-0.7-1.6-1.6s0.7-1.6,1.6-1.6s1.6,0.7,1.6,1.6S12.9,20,12,20z M12,18.4L12,18.4L12,18.4z"
			fill={colors[color]}
		/>
	</>
)

export const accountSettings: React.FC<IconPathProps> = ({
	color = defaultColor,
}) => (
	<>
		<path
			d="M4.50008 15.2504C4.22403 15.2498 4 15.0398 4 14.781C4.002 12.1972 6.24634 10.0946 9.00276 10.0946C9.68286 10.0952 10.3416 10.2215 10.9637 10.4696C11.2171 10.5709 11.3358 10.8465 11.2278 11.0846C11.1491 11.2578 10.9684 11.3697 10.7677 11.3697C10.7003 11.3697 10.6343 11.3572 10.5717 11.3322C10.0736 11.1334 9.54684 11.0321 9.00542 11.0321C7.9346 11.0321 6.93044 11.4215 6.17433 12.1291C5.41755 12.8372 5.00082 13.7791 5.00015 14.781C5.00015 15.0398 4.77545 15.2504 4.50008 15.2504Z"
			fill={colors[color]}
		/>
		<path
			d="M9.00074 10.094C7.20846 10.094 5.75024 8.72707 5.75024 7.047C5.75024 5.36693 7.20846 4 9.00074 4C10.793 4 12.2512 5.36693 12.2512 7.047C12.2512 8.72707 10.793 10.094 9.00074 10.094ZM9.00074 4.93754C7.75988 4.93754 6.7504 5.88383 6.7504 7.047C6.7504 8.21018 7.75988 9.15647 9.00074 9.15647C10.2416 9.15647 11.2511 8.21018 11.2511 7.047C11.2511 5.88383 10.2416 4.93754 9.00074 4.93754Z"
			fill={colors[color]}
		/>
		<path
			d="M15.5017 15.7192C14.6742 15.7192 14.0015 15.0886 14.0015 14.3129C14.0015 13.5373 14.6742 12.9066 15.5017 12.9066C16.3292 12.9066 17.0019 13.5373 17.0019 14.3129C17.0019 15.0886 16.3292 15.7192 15.5017 15.7192ZM15.5017 13.8442C15.2257 13.8442 15.0016 14.0542 15.0016 14.3129C15.0016 14.5717 15.2257 14.7817 15.5017 14.7817C15.7777 14.7817 16.0018 14.5711 16.0018 14.3129C16.0018 14.0548 15.7777 13.8442 15.5017 13.8442Z"
			fill={colors[color]}
		/>
		<path
			d="M15.5039 19.0001C15.3692 19.0001 15.2345 18.9813 15.1038 18.9444C14.6557 18.8188 14.3077 18.4925 14.1737 18.0725L13.8796 17.1662C13.8589 17.1018 13.7943 17.0575 13.7223 17.0575C13.7103 17.0575 13.6983 17.0587 13.6862 17.0612L12.7061 17.2737C12.6021 17.2956 12.4981 17.3069 12.3941 17.3069C12.132 17.3069 11.8753 17.2369 11.6519 17.1043C11.3372 16.9181 11.1192 16.6281 11.0372 16.2881C10.9358 15.8674 11.0625 15.4274 11.3759 15.1118L12.0633 14.4174C12.1227 14.3574 12.1227 14.2642 12.064 14.2042L11.3759 13.5092C11.1225 13.2542 10.9905 12.9217 11.0045 12.5729C11.0178 12.2241 11.1759 11.9016 11.4479 11.6641C11.7059 11.4385 12.0427 11.3147 12.3961 11.3147C12.4987 11.3147 12.6021 11.3254 12.7028 11.3466L13.6876 11.5604C13.6989 11.5629 13.7109 11.5641 13.7229 11.5641C13.7943 11.5641 13.8583 11.5197 13.8789 11.4554L14.1743 10.5466C14.281 10.2147 14.5197 9.94155 14.8464 9.77779C15.0478 9.67654 15.2738 9.62341 15.4999 9.62341C15.6359 9.62341 15.7712 9.64216 15.9026 9.67967C16.35 9.80655 16.6967 10.1328 16.8307 10.5528L17.1248 11.4591C17.1454 11.5235 17.2101 11.5679 17.2815 11.5679C17.2935 11.5679 17.3055 11.5666 17.3175 11.5641L18.2983 11.3516C18.401 11.3297 18.5043 11.3191 18.607 11.3191C19.2531 11.3191 19.8245 11.7473 19.9659 12.3379C20.0672 12.7585 19.9405 13.1979 19.6271 13.5142L18.9397 14.208C18.8804 14.268 18.8804 14.3617 18.9397 14.4211L19.6271 15.1161C19.8805 15.3712 20.0125 15.7037 19.9985 16.0524C19.9852 16.4006 19.8278 16.7237 19.5551 16.9612C19.2964 17.1869 18.9597 17.3106 18.6077 17.3106C18.5043 17.3106 18.4016 17.3 18.3009 17.2781L17.3168 17.0643C17.3055 17.0618 17.2935 17.0606 17.2815 17.0606C17.2101 17.0606 17.1461 17.105 17.1254 17.1694L16.8301 18.075C16.7247 18.4057 16.4867 18.6788 16.1606 18.8438C15.9573 18.9457 15.7306 19.0001 15.5039 19.0001ZM13.7223 16.1199C14.231 16.1199 14.6897 16.4387 14.8364 16.8943L15.1311 17.8019C15.1691 17.9206 15.2665 18.0119 15.3912 18.0469C15.4278 18.0569 15.4652 18.0625 15.5032 18.0625C15.5672 18.0625 15.6285 18.0475 15.6859 18.0188C15.7766 17.9731 15.8432 17.8963 15.8726 17.8038L16.168 16.8968C16.3153 16.4418 16.7734 16.1237 17.2815 16.1237C17.3681 16.1237 17.4555 16.1331 17.5408 16.1512L18.5236 16.3649C18.5497 16.3706 18.5783 16.3731 18.607 16.3731C18.7063 16.3731 18.801 16.3381 18.8744 16.2743C18.951 16.2074 18.9957 16.1162 18.9997 16.0181C19.0037 15.9199 18.9664 15.8262 18.895 15.7537L18.2076 15.0586C17.7935 14.6411 17.7935 13.9867 18.2076 13.5692L18.895 12.8754C18.9837 12.786 19.0197 12.6623 18.9911 12.5435C18.9684 12.4479 18.9064 12.366 18.8177 12.3135C18.7543 12.276 18.6823 12.256 18.6083 12.256C18.579 12.256 18.5497 12.2591 18.521 12.2654L17.5422 12.4779C17.4568 12.4967 17.3688 12.506 17.2815 12.506C16.7734 12.506 16.3153 12.1873 16.1686 11.7316L15.8739 10.8241C15.8359 10.7041 15.7392 10.6128 15.6139 10.5772C15.5772 10.5666 15.5392 10.5616 15.5012 10.5616C15.4378 10.5616 15.3765 10.576 15.3192 10.6047C15.2285 10.6503 15.1618 10.7266 15.1318 10.8191L14.8364 11.7285C14.6897 12.1841 14.2323 12.5023 13.7229 12.5023C13.6356 12.5023 13.5482 12.4929 13.4629 12.4748L12.4807 12.261C12.4547 12.2554 12.4261 12.2529 12.3974 12.2529C12.298 12.2529 12.2027 12.2879 12.13 12.3517C12.0533 12.4185 12.0087 12.5098 12.0047 12.6079C12.0007 12.706 12.038 12.7998 12.1093 12.8717L12.7974 13.5667C13.2115 13.9842 13.2115 14.6386 12.7974 15.0561L12.11 15.7499C12.0213 15.8393 11.9853 15.9631 12.014 16.0818C12.0373 16.1781 12.0987 16.2593 12.1874 16.3124C12.25 16.3499 12.3227 16.3693 12.3961 16.3693C12.4254 16.3693 12.4547 16.3662 12.4841 16.3599L13.4622 16.1474C13.5476 16.1293 13.6349 16.1199 13.7223 16.1199Z"
			fill={colors[color]}
		/>
	</>
)

export const logout: React.FC<IconPathProps> = ({ color = defaultColor }) => (
	<>
		<path
			d="M17.0008 15.502C16.8674 15.502 16.7414 15.45 16.6474 15.3554C16.4528 15.1607 16.4528 14.8434 16.6474 14.6481L18.294 13.0015H9.00119C8.72521 13.0015 8.50122 12.7775 8.50122 12.5015C8.50122 12.2256 8.72521 12.0016 9.00119 12.0016H18.2934L16.6468 10.355C16.5521 10.261 16.5001 10.135 16.5001 10.0017C16.5001 9.86836 16.5521 9.74236 16.6468 9.64837C16.7414 9.55437 16.8668 9.50171 17.0001 9.50171C17.1334 9.50171 17.2594 9.55371 17.3534 9.64837L19.8533 12.1482C19.8766 12.1716 19.8973 12.1969 19.9159 12.2242C19.9206 12.2309 19.9259 12.2409 19.9306 12.2496C19.9419 12.2682 19.9519 12.2876 19.9606 12.3076C19.9653 12.3182 19.9713 12.3376 19.9746 12.3482C19.9799 12.3616 19.9859 12.3822 19.9899 12.4042C19.9959 12.4329 19.9999 12.4669 19.9999 12.5015C19.9999 12.5349 19.9966 12.5682 19.9899 12.6002C19.9859 12.6202 19.9799 12.6395 19.9733 12.6589C19.9706 12.6695 19.9653 12.6842 19.9593 12.6975C19.9533 12.7129 19.9426 12.7329 19.9306 12.7529C19.9299 12.7549 19.9239 12.7669 19.9166 12.7775C19.9019 12.7989 19.8886 12.8155 19.8739 12.8315C19.8733 12.8335 19.8639 12.8449 19.8533 12.8549L17.3534 15.3547C17.2594 15.45 17.1341 15.502 17.0008 15.502Z"
			fill={colors[color]}
		/>
		<path
			d="M5.39747 19.9992C4.59218 19.9585 3.96555 19.2759 4.00221 18.4766L4.00154 6.49992C3.96488 5.71863 4.58551 5.04066 5.38547 5.00067L13.5917 5C14.4103 5.04 15.0363 5.72329 15.0003 6.52258L15.0009 9.49975C15.0009 9.77574 14.777 9.99973 14.501 9.99973C14.225 9.99973 14.001 9.77574 14.001 9.49975V6.49992C14.013 6.23127 13.8177 6.01194 13.5664 5.99928L5.41013 5.99995C5.18281 6.01194 4.98949 6.2306 5.00082 6.47725L5.00149 18.4993C4.98949 18.7679 5.18481 18.9872 5.43547 18.9999L13.5917 18.9992C13.819 18.9872 14.013 18.7686 14.0017 18.5219L14.001 15.4994C14.001 15.2234 14.225 14.9995 14.501 14.9995C14.777 14.9995 15.0009 15.2234 15.0009 15.4994V18.4993C15.0369 19.2812 14.4156 19.9585 13.6164 19.9985L5.41013 19.9992C5.40613 19.9992 5.40147 19.9992 5.39747 19.9992Z"
			fill={colors[color]}
		/>
	</>
)
export const linkedIn: React.FC<IconPathProps> = ({ color = defaultColor }) => (
	<>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M4.31365 9.38535H7.49032V20H4.31365V9.38535ZM5.88254 4C6.94143 4 7.80397 4.85834 7.80397 5.91206C7.80397 6.96578 6.94143 7.82412 5.88254 7.82412C4.82365 7.82412 4 6.96578 4 5.91206C4 4.85834 4.82365 4 5.88254 4ZM9.37285 9.38535H12.51V10.8686C13.1768 9.89286 14.2746 9.26862 15.5298 9.26862H16.3924C18.3922 9.26862 20 10.9079 20 12.8586V20H16.8629V19.0243V14.2632C16.8233 13.0534 16.0003 12.117 14.7846 12.117C13.5689 12.117 12.5495 13.0534 12.51 14.2632V20H9.37285V9.38535Z"
			fill={colors[color]}
		/>
	</>
)
export const facebook2: React.FC<IconPathProps> = ({
	color = defaultColor,
}) => (
	<>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M10.3822 20H13.3793V12.8493H15.5931L16.0357 9.96073H13.3793V7.77661C13.3793 6.96654 14.1288 6.50869 14.8436 6.50869H16.1378V4.11334L13.8219 4.00772C11.6086 3.86723 10.3822 5.66375 10.3822 7.81199V9.96073H7.86206V12.8493H10.3822V20Z"
			fill={colors[color]}
		/>
	</>
)
export const instagram: React.FC<IconPathProps> = ({
	color = defaultColor,
}) => (
	<>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			strokeLinejoin="round"
			strokeMiterlimit="2"
			d="M8.316,4L15.686,4C18.054,4 20.001,5.952 20.001,8.325L20.001,15.675C20.001,18.048 18.054,20 15.686,20L8.316,20C5.949,20 4.001,18.048 4.001,15.675L4.001,8.325C4.001,5.952 5.949,4 8.316,4ZM16.297,6.794C16.793,6.794 17.214,7.216 17.214,7.713C17.214,8.211 16.793,8.632 16.297,8.632C15.763,8.632 15.38,8.211 15.38,7.713C15.38,7.216 15.762,6.794 16.297,6.794ZM11.982,7.637L12.02,7.637C14.388,7.637 16.374,9.627 16.374,12.001C16.374,14.412 14.388,16.364 12.02,16.364L11.982,16.364C9.614,16.364 7.667,14.412 7.667,12.001C7.667,9.627 9.614,7.637 11.982,7.637ZM11.982,9.13L12.02,9.13C13.586,9.13 14.884,10.431 14.884,12.001C14.884,13.608 13.586,14.909 12.02,14.909L11.982,14.909C10.416,14.909 9.118,13.608 9.118,12.001C9.118,10.431 10.416,9.13 11.982,9.13ZM8.355,5.378L15.648,5.378C17.29,5.378 18.626,6.718 18.626,8.363L18.626,15.636C18.626,17.282 17.289,18.622 15.648,18.622L8.355,18.622C6.713,18.622 5.376,17.282 5.376,15.636L5.376,8.364C5.376,6.718 6.713,5.378 8.355,5.378L8.355,5.378Z"
			fill={colors[color]}
		/>
	</>
)
export const search: React.FC<IconPathProps> = ({ color = defaultColor }) => (
	<>
		<path
			d="M15.0085 15.0079L19.2382 19.2381M6.13308 13.2851C6.69882 14.6163 7.7702 15.6681 9.11152 16.2094C10.4528 16.7506 11.9542 16.7368 13.2854 16.1711C14.6166 15.6054 15.6685 14.5341 16.2098 13.1928C16.751 11.8515 16.7373 10.3502 16.1715 9.01906C15.6058 7.68793 14.5344 6.63605 13.1931 6.09482C11.8518 5.55359 10.3504 5.56735 9.01919 6.13306C7.68801 6.69878 6.63608 7.77012 6.09483 9.11139C5.55358 10.4527 5.56734 11.954 6.13308 13.2851Z"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
			fill="none"
			stroke={colors[color]}
		/>
	</>
)

export const ellipse: React.FC<IconPathProps> = ({ color = defaultColor }) => (
	<>
		<path d="M20.4853 20.4853C18.8071 22.1635 16.6689 23.3064 14.3411 23.7694C12.0133 24.2324 9.60051 23.9948 7.4078 23.0865C5.21509 22.1783 3.34094 20.6402 2.02237 18.6668C0.703788 16.6934 4.10743e-07 14.3734 4.10743e-07 12C5.7933e-07 9.62661 0.703788 7.30653 2.02237 5.33314C3.34094 3.35975 5.21509 1.82168 7.4078 0.913427C9.60051 0.00517565 12.0133 -0.232464 14.3411 0.230558C16.6689 0.693581 18.8071 1.83647 20.4853 3.5147L19.0459 4.95412C17.6523 3.56057 15.8768 2.61156 13.944 2.22708C12.0111 1.84261 10.0076 2.03994 8.1868 2.79411C6.36606 3.54829 4.80984 4.82545 3.71494 6.46408C2.62004 8.10271 2.03564 10.0292 2.03564 12C2.03564 13.9707 2.62004 15.8973 3.71494 17.5359C4.80984 19.1745 6.36606 20.4517 8.1868 21.2058C10.0076 21.96 12.0111 22.1574 13.944 21.7729C15.8768 21.3884 17.6523 20.4394 19.0459 19.0458L20.4853 20.4853Z" fill={colors[color]} />
	</>
)

export const geoPosition: React.FC<IconPathProps> = ({ color = defaultColor }) => (
	<>
		<path fill-rule="evenodd" clip-rule="evenodd" d="M16.2732 3.22678C16.4992 3.45274 16.5631 3.79433 16.4341 4.0867L10.0584 18.5382C9.91069 18.8731 9.5486 19.0588 9.19044 18.9833C8.83228 18.9078 8.57593 18.5918 8.57593 18.2257V10.9241H1.27427C0.908234 10.9241 0.592219 10.6677 0.516723 10.3096C0.441228 9.9514 0.626883 9.58931 0.961772 9.44156L15.4133 3.06589C15.7057 2.9369 16.0473 3.00081 16.2732 3.22678ZM4.94711 9.37569H9.35012C9.77769 9.37569 10.1243 9.72231 10.1243 10.1499V14.5529L14.2116 5.28844L4.94711 9.37569Z" fill={colors[color]} />
	</>
)
